export const DEFAULT_INPUT_DELAY = 300;
export const DEFAULT_INPUT_BLUR_DELAY = 300;
export const ERROR_HIDE_DELAY = 6000;
